var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('h1',[_vm._v("Estamos desenvolvendo um ambiente mais dinâmico.")]),_c('h3',[_vm._v("Em breve voltaremos com novas ofertas de "),_c('a',{attrs:{"href":"/desossador"}},[_vm._v("emprego")]),_vm._v(".")])])}
var staticRenderFns = []

export { render, staticRenderFns }